angular.module('mandaeApp')
    .service('Alert', function () {
        var alerts = [];
        this.add = function(type, msg) {
            var self = this;            
            alerts.push({
                type: type,
                msg: msg,
                close: function() {
                    return self.closeAlert(this);
                }
            });
            $timeout(function() {
                self.closeAlert(this); 
            }, 3000);
        },
        this.closeAlert = function(alert) {
            return this.closeAlertIdx(alerts.indexOf(alert));
        },
        this.closeAlertIdx = function(index) {
            return alerts.splice(index, 1);
        },
        this.alertData = function() {
            return alerts;
        }
    });